import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './GalleryViewerPage.css';

// Import SVG icons
import { ReactComponent as ArrowLeftIcon } from '../../../assets/icons/arrow-left.svg';

interface GalleryViewerPageProps extends WithTranslation {
  navigate?: (path: string, options?: any) => void;
  location?: any;
  albums?: any[];
  initialPage?: number;
  previousPage?: string;
  goalId?: string;
}

interface GalleryViewerPageState {
  currentPage: number;
}

class GalleryViewerPage extends Component<GalleryViewerPageProps, GalleryViewerPageState> {
  constructor(props: GalleryViewerPageProps) {
    super(props);
    this.state = {
      currentPage: props.initialPage || 0,
    };
  }

  _onPageChange = (index: number) => {
    this.setState({ currentPage: index });
  };

  _onBackPress = () => {
    if (this.props.navigate) {

      console.log('this.props.previousPage', this.props.location?.state?.previousPage);
      console.log('this.props.goalId', this.props.location?.state?.goalId);
      
      // previous page page GalleryViewer or GoalIndividual
      if (this.props.location?.state?.previousPage === 'GoalComment') {
        this.props.navigate(`/goals/comment/${this.props.goalId}`);
        // this.props.navigate(-1);
      } else if (this.props.location?.state?.previousPage === 'GoalIndividual') {
        this.props.navigate(`/goals/individual/${this.props.goalId}`);
      }

      // this.props.navigate(`/goals/individual/${this.props.location.state.goalId}`);
    }
  };

  render() {
    const { t, albums = [], location } = this.props;
    const { currentPage } = this.state;

    // Extract albums from location state if not passed as props (matching reference project)
    const albumsData = albums.length > 0 ? albums : (location?.state?.albums || []);
    const initialPage = location?.state?.initialPage || 0;

    return (
      <div className="galleryviewer-page">
        <div className="galleryviewer-container">
          {/* Header Section - matching reference project design */}
          <header className="page-header">
            <div className="page-header-inner">
              <div className="header-left">
                <button 
                  className="header-button back-button" 
                  onClick={this._onBackPress}
                  aria-label="Go back to goals"
                  title="Go back to goals"
                >
                  <ArrowLeftIcon />
                </button>
              </div>
              <div className="header-center">
                {/* Empty center section to match reference project */}
              </div>
              <div className="header-right">
                {/* Empty right section to match reference project */}
              </div>
            </div>
          </header>

          {/* Carousel Container - using react-responsive-carousel */}
          <div className="page-content">
            <div className="carousel-container">
              {albumsData.length > 0 ? (
                <Carousel
                  selectedItem={initialPage}
                  onChange={this._onPageChange}
                  showArrows={false}
                  showStatus={false}
                  showThumbs={false}
                  showIndicators={true}
                  infiniteLoop={false}
                  autoPlay={false}
                  interval={3000}
                  stopOnHover={true}
                  swipeable={true}
                  emulateTouch={true}
                  dynamicHeight={true}
                  centerMode={false}
                  centerSlidePercentage={100}
                  className="gallery-carousel"
                >
                  {albumsData.map((image: any, index: number) => (
                    <div key={index} className="carousel-slide">
                      <img 
                        src={image.url} 
                        alt={`Image ${index + 1}`}
                        className="carousel-image"
                      />
                    </div>
                  ))}
                </Carousel>
              ) : (
                <div className="empty-state">
                  <p>{t ? t('gallery-viewer-screen:empty.no-images') : 'No images available'}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Redux connection - simplified
const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(GalleryViewerPage));
